import React from 'react';
import ErrorPage from './ErrorPage';
import { ApiCall } from '../helper/axios';
import { getUserToken } from '../helper/commonFunction';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Log error details for debugging
        console.error('Error caught by boundary:', error, errorInfo);
        this.setState({
            error: error,
            errorInfo: errorInfo
        });

        // Report error to backend API
        this.reportErrorToBackend(error, errorInfo);
    }

    reportErrorToBackend = async (error, errorInfo) => {
        try {
            const userToken = getUserToken();
            const url = window.location.href;
            
            const payload = {
                error: error?.toString() || error?.message || 'Unknown error',
                errorMessage: error?.message || 'No error message provided',
                errorStack: error?.stack || errorInfo?.componentStack || 'No stack trace available',
                url: url || 'URL not provided',
                additionalData: {
                    errorName: error?.name || 'Error',
                    componentStack: errorInfo?.componentStack || null,
                    errorInfo: errorInfo || {}
                }
            };

            const header = {};
            if (userToken) {
                header['authorization'] = userToken;
            }

            // Call backend API to report error
            await ApiCall('POST', '/frontend-error-report', payload, header);
        } catch (reportError) {
            // Silently fail if error reporting fails to avoid infinite loops
            console.error('Failed to report error to backend:', reportError);
        }
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null, errorInfo: null });
        // Optionally reload the page or navigate to home
        window.location.reload();
    }

    render() {
        if (this.state.hasError) {
            // Render custom error UI
            return <ErrorPage onRetry={this.handleReset} />;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;


